import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AffirmativeStatement = () => {
  const [loading, setLoading] = useState(true);
  const userData = useSelector((state) => state.userData);
  const navigate = useNavigate();
  // Try to get AffirmativePath from userData.userData, then fallback to userData.registration.registrationData
  const affirmativePath = userData?.userData?.AffirmativePath || userData?.registration?.registrationData?.AffirmativePath;

  if (!affirmativePath) {
    return <div style={{ padding: 32, textAlign: 'center' }}>Affirmative Statement link not available.</div>;
  }
const handleBackClick = () => {
    navigate("/home");
  };
  return (
    <div style={{ width: '100%', height: 'calc(100vh - 100px)', padding: 0, margin: 0, position: 'relative' }}>
        <button className="win-back-btn" onClick={handleBackClick}>
        <span>
          <i className="bi bi-chevron-left"></i>
          Back
        </span>
      </button>
      {loading && (
        <div className="loading-container">
      <div className="loading"></div>        
      <h2 className="loading-text">Loading...</h2>
    </div>
      )}
      <iframe
        src={affirmativePath}
        title="Affirmative Statement"
        style={{ width: '100%', height: '100%', border: 'none', padding: '30px' }}
        allowFullScreen
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default AffirmativeStatement;
